module.exports = __webpack_public_path__ + "img/DNARepair-OVCA_10X_WTA.405f5925.png";